import { useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@cbhq/cds-web/buttons';
import { ListCell } from '@cbhq/cds-web/cells';
import { Pictogram } from '@cbhq/cds-web/illustrations/Pictogram';
import { HStack, VStack } from '@cbhq/cds-web/layout';
import { TextBody, TextTitle1 } from '@cbhq/cds-web/typography';

import { useCreateProjectAndPushRoute } from ':cloud/hooks/useCreateProjectAndPushRoute';
import { useSimpleBreakpoints } from ':cloud/hooks/useSimpleBreakpoints';
import { BaseNetworkEnum } from ':cloud/types/ts_types';

export function NewBaseProject() {
  const { isPhone } = useSimpleBreakpoints();
  const history = useHistory();
  const [selectedNetwork, setSelectedNetwork] = useState<BaseNetworkEnum>(BaseNetworkEnum.Mainnet);
  const createProject = useCreateProjectAndPushRoute();

  const handleSelectNetwork = useCallback((network: BaseNetworkEnum) => {
    return () => setSelectedNetwork(network);
  }, []);

  const handleCancel = useCallback(() => {
    history.go(-1);
  }, [history]);

  const handleSubmit = useCallback(() => {
    createProject('base', selectedNetwork);
  }, [createProject, selectedNetwork]);

  const dangerousStyle = useMemo(() => {
    return { marginTop: isPhone ? '0' : '200px' };
  }, [isPhone]);

  return (
    <VStack alignItems="center" style={dangerousStyle}>
      <VStack width={isPhone ? '100%' : 450} bordered={!isPhone} borderRadius="rounded">
        <VStack spacingVertical={6} spacingHorizontal={7}>
          <TextTitle1 as="h1">Choose a network for Base Node</TextTitle1>
          <TextBody as="p" color="foregroundMuted" spacingTop={1} spacingBottom={3}>
            This selection cannot be modifed.
          </TextBody>

          <ListCell
            title="Base Mainnet"
            description="For production-ready apps"
            media={<Pictogram name="baseLogoNavigation" dimension="48x48" scaleMultiplier={0.5} />}
            variant="positive"
            onPress={handleSelectNetwork(BaseNetworkEnum.Mainnet)}
            selected={selectedNetwork === BaseNetworkEnum.Mainnet}
          />
          <ListCell
            title="Base Sepolia"
            description="For apps in development"
            media={<Pictogram name="baseLogoNavigation" dimension="48x48" scaleMultiplier={0.5} />}
            variant="positive"
            onPress={handleSelectNetwork(BaseNetworkEnum.Testnet)}
            selected={selectedNetwork === BaseNetworkEnum.Testnet}
          />
        </VStack>
        <HStack spacingHorizontal={7} spacingVertical={3} justifyContent="flex-end" gap={2}>
          <Button variant="secondary" onPress={handleCancel}>
            Cancel
          </Button>
          <Button variant="primary" onPress={handleSubmit}>
            Submit
          </Button>
        </HStack>
      </VStack>
    </VStack>
  );
}
